import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap, tap, catchError } from 'rxjs/operators';

import { StateService } from './base-states/base-state';
import { LocalStorageKeys } from '../../shared/helpers/app.constants';
import { AppUtils } from '../../shared/helpers/app.utils';
import { IAuthTokenModel, IClientDeviceModel } from '../../shared/models/auth.model';
import { AccountService } from '../http-services/account.service';
import { ClientIpService } from '../http-services/client-ip.service';

const initialState: IClientDeviceModel = {
};

@Injectable({
  providedIn: 'root'
})
export class ClientDeviceStateService extends StateService<IClientDeviceModel> {

  constructor(
    private readonly clientIpService: ClientIpService,
    private readonly accountService: AccountService,
    private readonly appUtils: AppUtils,
  ) {
    super(initialState);
  }

  initialize(): Observable<string | null> {
    const guestToken = localStorage.getItem(LocalStorageKeys.GuestToken);
    const localId = this.getOrCreateLocalId();

    const guestDetails = guestToken ? this.appUtils.getClientDetail() : null;

    if (guestToken && guestDetails?.localId === localId) {
      const guestDetails = this.appUtils.getClientDetail();
      this.setState({ ...guestDetails });
      return of(guestToken);
    }

    return this.clientIpService.getClientIp().pipe(
      switchMap(ipDetails => {
        const model: IClientDeviceModel = { ...ipDetails, localId: localId };
        return this.accountService.guestToken(model).pipe(
          tap((result: IAuthTokenModel) => {
            // save token
            localStorage.setItem(LocalStorageKeys.GuestToken, result.accessToken.toString());

            // update state
            const guestDetails = this.appUtils.getClientDetail();
            this.setState({ ...ipDetails, id: guestDetails?.id });
          }),
          switchMap((result: IAuthTokenModel) => of(result.accessToken.toString()))
        );
      }),
      catchError(err => {
        console.error('Error initializing guest token:', err);
        return of(null);
      })
    );
  }

  private getOrCreateLocalId(): string {
    let localId = localStorage.getItem(LocalStorageKeys.LocalId);

    if (!localId) {
      localId = crypto.randomUUID();
      localStorage.setItem(LocalStorageKeys.LocalId, localId);
    }

    return localId;
  }
}
